import styled from 'styled-components';

/**
 * This component enforces a maximum page width of 1280px and centers the content.
 * Wrap this around content that should not stretch infinitely.
 */
const EnforcePageWidth = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`;

/**
 * This component enforces a maximum page width of 1920px and centers the content.
 * Suitable for wide content like images, carousels.
 */
const EnforceWidePageWidth = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 1rem;
`;

/**
 * This component creates a grid with two columns that are at least 400px wide.
 */
const DualSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(400px, 100%), 1fr));
  padding-bottom: 5rem;
  gap: 4rem;
  max-width: 100%;
`;

const CenteredText = styled.div`
  text-align: center;
  width: 100%;

  h2 {
    font-size: 3.5rem;
  }
`;

/**
 * Add the gradient background to a section.
 */
const StyledColoredBackground = styled.div`
  background: radial-gradient(99.87% 99.87% at 50.89% 69.53%, rgba(15, 156, 139, 0.08) 0%, rgba(217, 217, 217, 0) 100%);
  padding: 2rem 0;
`;

const StyledBackgroundGradient = styled.div`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 150px;
    height: 20%;
    background: #0f9c8c14;
    background: linear-gradient(0deg, #0f9c8c14, #d9d9d900);
    z-index: -1;
  }
`;

const StyledBackgroundGradientFlipped = styled.div`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    max-height: 150px;
    height: 20%;
    background: #d9d9d900;
    background: linear-gradient(0deg, #d9d9d900, #0f9c8c14);
    z-index: -1;
  }
`;

export {
  EnforcePageWidth,
  EnforceWidePageWidth,
  DualSection,
  CenteredText,
  StyledColoredBackground,
  StyledBackgroundGradient,
  StyledBackgroundGradientFlipped,
};
